import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { GlobalResponse, UpdateDoctorLeadRequest } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { AdminService } from '@app/services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-update-doctor-lead',
  templateUrl: './update-doctor-lead.component.html',
  styleUrls: ['./update-doctor-lead.component.css']
})
export class UpdateDoctorLeadDialogComponent implements OnInit {
  public headerTitle: string;
  clinicName: string;
  firstName: string;
  lastName: string;
  emailId: string;
  mobileNumber: string;
  keySkills: string;
  qualification: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  pincode: string;
  @BlockUI() blockUI: NgBlockUI;
  public leadData: any;
  public doctorLeadID: string;
  constructor(
    public dialogRef: MatDialogRef<UpdateDoctorLeadDialogComponent>,
    private service: AdminService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.leadData) {
      this.clinicName = this.leadData.clinic_name ? this.leadData.clinic_name : '';
      this.firstName = this.leadData.first_name ? this.leadData.first_name : '';
      this.lastName = this.leadData.last_name ? this.leadData.last_name : '';
      this.emailId = this.leadData.email_id ? this.leadData.email_id : '';
      this.mobileNumber = this.leadData.phone_no ? this.leadData.phone_no : '';
      this.keySkills = this.leadData.key_skills ? this.leadData.key_skills : '';
      this.qualification = this.leadData.qualification ? this.leadData.qualification : '';
      this.addressLine1 = this.leadData.address.address_line1 ? this.leadData.address.address_line1 : '';
      this.addressLine2 = this.leadData.address.address_line2 ? this.leadData.address.address_line2 : '';
      this.city = this.leadData.address.city ? this.leadData.address.city : '';
      this.state = this.leadData.address.state ? this.leadData.address.state : '';
      this.pincode = this.leadData.address.pincode ? this.leadData.address.pincode : '';
    }
  }

  updateItem() {
    if (this.clinicName && this.clinicName.length > 0 &&
      this.firstName && this.firstName.length > 0 &&
      this.lastName && this.lastName.length > 0 &&
      this.emailId && this.emailId.length > 0 &&
      this.mobileNumber && this.mobileNumber.length > 0 &&
      this.keySkills && this.keySkills.length > 0 &&
      this.qualification && this.qualification.length > 0 &&
      this.addressLine1 && this.addressLine1.length > 0 &&
      this.addressLine2 && this.addressLine2.length > 0 &&
      this.city && this.city.length > 0 &&
      this.state && this.state.length > 0 &&
      this.pincode && this.pincode.length > 0) {
      const leadItem: UpdateDoctorLeadRequest = {
        clinicName: this.clinicName,
        firstName: this.firstName,
        lastName: this.lastName,
        emailId: this.emailId,
        mobileNumber: this.mobileNumber,
        keySkills: this.keySkills,
        qualification: this.qualification,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        city: this.city,
        state: this.state,
        pincode: this.pincode
      };
      this.blockUI.start();
      this.service.updateDoctorLead(leadItem, this.doctorLeadID).subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.dialogRef.close(res.result);
        }
      });
    } else {
      this.toastr.error('Please enter all the fields');
    }
  }

  createItem() {
    // const newItem: DrugRequest = {} as DrugRequest;
    // newItem.category = this.category;
    // newItem.name = this.name;
    // newItem.price = this.price;
    // newItem.qty = this.qty;
    // this.service.createDrug(newItem).subscribe((res: GlobalResponse) => {
    //   if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
    //     // console.log(res.result);
    //     this.dialogRef.close(newItem);
    //   }
    // });
  }

}
